// Mini Site template registry — single source of truth.
// Layout/structure are FIXED per template. Only content is editable.

export type MiniSiteTemplateId =
  | "ritual-diary"
  | "diario"
  | "classic"
  | "art-gallery"
  | "gallery3d"
  | "curadoria"
  | "persona"
  | "indice"
  | "estudio";


export type MiniSiteTier = "free" | "pro";

export type MiniSiteTemplate = {
  id: MiniSiteTemplateId;
  name: string;
  description: string;
  tier: MiniSiteTier;
  thumb: MiniSiteTemplateId;
  isNew?: boolean;
};

export const MINI_SITE_TEMPLATES: MiniSiteTemplate[] = [
  {
    id: "ritual-diary",
    name: "Diário de Ritual",
    description: "Um diário minimalista para publicar os discos e reflexões que você escolher.",
    tier: "free",
    thumb: "ritual-diary",
    isNew: true,
  },
  {
    id: "diario",
    name: "Diário",
    description:
      "Padrão. Para quem ama mostrar a coleção e as próprias notas: destaques com as melhores avaliações, grid de capas com estrelas e stats de nota média.",
    tier: "free",
    thumb: "diario",
    isNew: true,
  },
  {
    id: "classic",
    name: "Bolacha",
    description: "Capa, identidade e links — o básico bem feito.",
    tier: "free",
    thumb: "classic",
  },

  {
    id: "art-gallery",
    name: "Art Gallery",
    description:
      "Sua coleção em um grid infinito com distorção de lente e navegação por arraste.",
    tier: "pro",
    thumb: "art-gallery",
    isNew: true,
  },
  {
    id: "gallery3d",
    name: "Galeria 3D",
    description:
      "Experiência imersiva 3D: suas capas flutuam no espaço com efeito de profundidade, blur e ondulação ao scroll. Seu nome fixo no topo, como uma assinatura.",
    tier: "pro",
    thumb: "gallery3d",
    isNew: true,
  },
  {
    id: "curadoria",
    name: "Colecionador",
    description:
      "Sidebar com seu perfil, bio e gêneros — e uma parede limpa e editorial das suas capas em grid uniforme.",
    tier: "pro",
    thumb: "curadoria",
  },
  {
    id: "persona",
    name: "Vendedor",
    description:
      "Topbar com filtro de gênero e CTA de contato, grid de pôsteres em cores fortes destacando título e preço de cada disco à venda.",
    tier: "pro",
    thumb: "persona",
  },
  {
    id: "indice",
    name: "Índice",
    description:
      "Tipografia gigante com seu nome, bio, cidade e badges de gosto — e um índice editorial dos discos com o ano alinhado na borda.",
    tier: "free",
    thumb: "indice",
    isNew: true,
  },
  {
    id: "estudio",
    name: "Estúdio",
    description:
      "Headline monumental com selo [SELECTED WORKS], retrato, bio, cidade e badges — e grid editorial de capas numeradas.",
    tier: "free",
    thumb: "estudio",
    isNew: true,
  },
];


export function getTemplate(id: string): MiniSiteTemplate {
  return MINI_SITE_TEMPLATES.find((t) => t.id === id) ?? MINI_SITE_TEMPLATES[0];
}

export function isPremiumTemplate(id: string): boolean {
  return getTemplate(id).tier === "pro";
}
